import { render, staticRenderFns } from "./newOaWorkflowFormEditList.vue?vue&type=template&id=2222c205&scoped=true"
import script from "./newOaWorkflowFormEditList.vue?vue&type=script&lang=js"
export * from "./newOaWorkflowFormEditList.vue?vue&type=script&lang=js"
import style0 from "./newOaWorkflowFormEditList.vue?vue&type=style&index=0&id=2222c205&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2222c205",
  null
  
)

export default component.exports